import { requestApi } from "../base/request";

export function getDataListHandler(api, params, options) {
    return requestApi(api, Object.assign({}, params, options)).then(resp => {
        return resp.data;
    }).catch((err) => {
        throw err && err.msg;
    })
}

export function getDataDetailHandler(api, params) {
    return requestApi(api, params).then(resp => {
        return resp.data;
    }).catch((err) => {
        throw err && err.msg;
    })
}

export function getUploadFileHandler(file, type) {
    return new Promise((resolve, reject) => {
        let reader = new FileReader()
        reader.readAsDataURL(file);
        reader.onerror = (e) => { reject(e); }
        reader.onload = () => {
            let fileName = file.name;
            let base64Str = reader.result;
            requestApi("biz.customer.upload.file", {
                type: type,
                fileBase64: base64Str.split(",")[1],
                fileName: fileName,
            }, {
                timeout: 1000 * 60 * 60 * 24,
                showError: true
            }).then((resp) => {
                if (resp.data && resp.data.url) {
                    return resp.data.url;
                } else {
                    throw resp.err || resp.msg || "上传失败";
                }
            }).then(resolve).catch(reject);
        }
    })
}
